import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { TagIcon, PlusIcon, CalendarIcon } from 'lucide-react';
import { Card } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Badge } from '../../components/ui/Badge';
import { Tabs } from '../../components/ui/Tabs';
import { formatDate } from '../../lib/formatters';
import { MOCK_PROMOTIONS } from '../../lib/mockData';
export function PromotionsPage() {
  const [activeTab, setActiveTab] = useState('all');
  const statusMap: Record<string, string> = {
    active: 'Đang chạy',
    scheduled: 'Đã lên lịch',
    expired: 'Hết hạn',
    draft: 'Nháp'
  };
  const statusVariant: Record<string, 'success' | 'warning' | 'default' | 'info'> = {
    active: 'success',
    scheduled: 'info',
    expired: 'default',
    draft: 'warning'
  };
  const tabs = [{
    id: 'all',
    label: 'Tất cả',
    count: MOCK_PROMOTIONS.length
  }, {
    id: 'active',
    label: 'Đang chạy',
    count: MOCK_PROMOTIONS.filter(p => p.status === 'active').length
  }, {
    id: 'scheduled',
    label: 'Đã lên lịch',
    count: MOCK_PROMOTIONS.filter(p => p.status === 'scheduled').length
  }, {
    id: 'expired',
    label: 'Hết hạn',
    count: MOCK_PROMOTIONS.filter(p => p.status === 'expired').length
  }];
  const filtered = activeTab === 'all' ? MOCK_PROMOTIONS : MOCK_PROMOTIONS.filter(p => p.status === activeTab);
  return <div data-id="element-889">
      <motion.div initial={{
      opacity: 0,
      y: 12
    }} animate={{
      opacity: 1,
      y: 0
    }} data-id="element-890">
        <div className="flex items-center justify-between mb-6" data-id="element-891">
          <div data-id="element-892">
            <h1 className="text-2xl font-bold text-white flex items-center gap-3" data-id="element-893">
              <TagIcon className="w-7 h-7 text-[#C8A84E]" data-id="element-894" />
              Khuyến Mãi
            </h1>
            <p className="text-sm text-[#666666]" data-id="element-895">
              Quản lý chương trình khuyến mãi
            </p>
          </div>
          <Button data-id="element-896">
            <PlusIcon className="w-4 h-4" data-id="element-897" />
            Tạo Mới
          </Button>
        </div>
      </motion.div>

      <Tabs tabs={tabs} activeTab={activeTab} onTabChange={setActiveTab} className="mb-4" data-id="element-898" />

      <div className="space-y-4" data-id="element-899">
        {filtered.map((promo, i) => <motion.div key={promo.id} initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        delay: i * 0.03
      }} data-id="element-900">
            <Card data-id="element-901">
              <div className="flex flex-col md:flex-row md:items-center gap-4" data-id="element-902">
                <div className="flex-1 min-w-0" data-id="element-903">
                  <div className="flex items-center gap-2 mb-1" data-id="element-904">
                    <h3 className="font-semibold text-white" data-id="element-905">{promo.nameVi}</h3>
                    <Badge variant={statusVariant[promo.status]} size="sm" data-id="element-906">
                      {statusMap[promo.status]}
                    </Badge>
                    <Badge size="sm" data-id="element-907">{promo.type}</Badge>
                  </div>
                  <p className="text-sm text-[#B0B0B0] mb-2" data-id="element-908">
                    {promo.description}
                  </p>
                  <div className="flex items-center gap-4 text-xs text-[#666666]" data-id="element-909">
                    <span className="flex items-center gap-1" data-id="element-910">
                      <CalendarIcon className="w-3 h-3" data-id="element-911" />
                      {formatDate(promo.startDate)} –{' '}
                      {formatDate(promo.endDate)}
                    </span>
                    {promo.pointMultiplier && <span data-id="element-912">Điểm x{promo.pointMultiplier}</span>}
                    {promo.discountPercent && <span data-id="element-913">Giảm {promo.discountPercent}%</span>}
                  </div>
                </div>
                <div className="flex gap-2" data-id="element-914">
                  <Button size="sm" variant="ghost" data-id="element-915">
                    Sửa
                  </Button>
                  <Button size="sm" variant="ghost" data-id="element-916">
                    Xem
                  </Button>
                </div>
              </div>
            </Card>
          </motion.div>)}
      </div>
    </div>;
}